(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["life-watch-accordion"] && !Shopify.designMode) return;
  try {
    
  function initLifeWatchAccordions(root) {
    var sections = (root || document).querySelectorAll('.lwacc');
    sections.forEach(function (section) {
      if (section.dataset.lwaccInit === 'true') return;
      section.dataset.lwaccInit = 'true';

      var items = section.querySelectorAll('[data-lwacc-item]');

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-lwacc-toggle]');
        var body = item.querySelector('[data-lwacc-body]');

        toggle.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          items.forEach(function (otherItem) {
            var otherToggle = otherItem.querySelector('[data-lwacc-toggle]');
            var otherBody = otherItem.querySelector('[data-lwacc-body]');
            otherItem.classList.remove('is-open');
            otherToggle.setAttribute('aria-expanded', 'false');
            otherBody.setAttribute('hidden', '');
          });

          if (willOpen) {
            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            body.removeAttribute('hidden');

            var index = item.getAttribute('data-index');
            var visuals = section.querySelectorAll('[data-lwacc-visual]');
            visuals.forEach(function (img) {
              if (img.getAttribute('data-index') === index) {
                img.classList.add('is-active');
              } else {
                img.classList.remove('is-active');
              }
            });
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLifeWatchAccordions(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initLifeWatchAccordions(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-watch-bundle"] && !Shopify.designMode) return;
  try {
    
  function lwbundleInit(root) {
    var sections = (root || document).querySelectorAll('[data-lwbundle]');
    sections.forEach(function (section) {
      if (section.dataset.lwbundleInit === 'true') return;
      section.dataset.lwbundleInit = 'true';

      var quantity = 1;
      var qtyValueEl = section.querySelector('[data-lwbundle-qty-value]');
      var qtyDecreaseBtn = section.querySelector('[data-lwbundle-qty-decrease]');
      var qtyIncreaseBtn = section.querySelector('[data-lwbundle-qty-increase]');

      var swatchButtons = section.querySelectorAll('[data-lwbundle-swatch]');
      var selectedLabelEl = section.querySelector('[data-lwbundle-selected-label]');
      var bandPriceEl = section.querySelector('[data-lwbundle-band-price]');
      var subtotalEl = section.querySelector('[data-lwbundle-subtotal]');
      var discountEl = section.querySelector('[data-lwbundle-discount]');
      var bundlePriceEl = section.querySelector('[data-lwbundle-bundle-price]');
      var totalValueEl = section.querySelector('[data-lwbundle-total-value]');
      var saveBadgeEl = section.querySelector('[data-lwbundle-save-badge]');
      var addButton = section.querySelector('[data-lwbundle-add-to-cart]');
      var addLabelEl = section.querySelector('[data-lwbundle-add-label]');

      var lifeWatchVariantId = section.getAttribute('data-life-watch-variant-id');
      var lifeWatchPriceCents = parseInt(section.getAttribute('data-life-watch-price-cents'), 10) || 0;
      var screenProtectorVariantId = section.getAttribute('data-screen-protector-variant-id');
      var screenProtectorPriceCents = parseInt(section.getAttribute('data-screen-protector-price-cents'), 10) || 0;
      var discountPercentage = parseFloat(section.getAttribute('data-discount-percentage')) || 0;

      var activeSwatch = section.querySelector('[data-lwbundle-swatch].is-active') || swatchButtons[0];
      var addLabelDefaultText = addLabelEl ? addLabelEl.textContent : '';

      function formatMoney(cents) {
        return (cents / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
        });
      }

      function recalculate() {
        if (!activeSwatch) return;
        var bandPriceCents = parseInt(activeSwatch.getAttribute('data-price-cents'), 10) || 0;
        var subtotalCents = lifeWatchPriceCents + bandPriceCents + screenProtectorPriceCents;
        var discountCents = Math.round((subtotalCents * discountPercentage) / 100);
        var bundlePriceCents = subtotalCents - discountCents;

        if (bandPriceEl) bandPriceEl.textContent = formatMoney(bandPriceCents);
        if (subtotalEl) subtotalEl.textContent = formatMoney(subtotalCents);
        if (discountEl) discountEl.textContent = '\u2212' + formatMoney(discountCents);
        if (bundlePriceEl) bundlePriceEl.textContent = formatMoney(bundlePriceCents);
        if (totalValueEl) totalValueEl.textContent = formatMoney(subtotalCents);
        if (saveBadgeEl) {
          var saveLabel = saveBadgeEl.textContent.replace(/[\d.]+%/, discountPercentage + '%');
          saveBadgeEl.textContent = saveLabel;
        }
      }

      swatchButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          swatchButtons.forEach(function (b) {
            b.classList.remove('is-active');
            b.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
          activeSwatch = button;
          if (selectedLabelEl) selectedLabelEl.textContent = button.getAttribute('data-label') || '';
          recalculate();
        });
      });

      if (qtyDecreaseBtn) {
        qtyDecreaseBtn.addEventListener('click', function () {
          quantity = Math.max(1, quantity - 1);
          qtyValueEl.textContent = quantity;
        });
      }
      if (qtyIncreaseBtn) {
        qtyIncreaseBtn.addEventListener('click', function () {
          quantity = quantity + 1;
          qtyValueEl.textContent = quantity;
        });
      }

      if (addButton) {
        addButton.addEventListener('click', function () {
          if (!activeSwatch) return;
          var bandVariantId = activeSwatch.getAttribute('data-variant-id');

          var items = [];
          if (lifeWatchVariantId) items.push({ id: parseInt(lifeWatchVariantId, 10), quantity: quantity });
          if (bandVariantId) items.push({ id: parseInt(bandVariantId, 10), quantity: quantity });
          if (screenProtectorVariantId) items.push({ id: parseInt(screenProtectorVariantId, 10), quantity: quantity });

          if (items.length === 0) return;

          addButton.disabled = true;
          if (addLabelEl) addLabelEl.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('Add to cart failed');
              return response.json();
            })
            .then(function () {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
                ? window.Shopify.routes.root + 'cart'
                : '/cart';
            })
            .catch(function () {
              addButton.disabled = false;
              if (addLabelEl) addLabelEl.textContent = addLabelDefaultText;
              alert('Something went wrong adding the bundle to your cart. Please try again.');
            });
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    lwbundleInit(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    lwbundleInit(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-watch-faq"] && !Shopify.designMode) return;
  try {
    
  function lwfaqInitAccordions(root) {
    var sections = (root || document).querySelectorAll('.lwfaq');
    sections.forEach(function (section) {
      if (section.dataset.lwfaqInit === 'true') return;
      section.dataset.lwfaqInit = 'true';

      var items = section.querySelectorAll('[data-lwfaq-item]');

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-lwfaq-toggle]');
        var body = item.querySelector('[data-lwfaq-body]');

        toggle.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          items.forEach(function (otherItem) {
            var otherToggle = otherItem.querySelector('[data-lwfaq-toggle]');
            var otherBody = otherItem.querySelector('[data-lwfaq-body]');
            otherItem.classList.remove('is-open');
            otherToggle.setAttribute('aria-expanded', 'false');
            otherBody.setAttribute('hidden', '');
          });

          if (willOpen) {
            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            body.removeAttribute('hidden');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    lwfaqInitAccordions(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    lwfaqInitAccordions(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["life-watch-testimonials"] && !Shopify.designMode) return;
  try {
    
  function lwtLoadSwiperScript(callback) {
    if (window.Swiper) {
      callback();
      return;
    }
    if (window.__lwtSwiperLoading) {
      window.__lwtSwiperCallbacks = window.__lwtSwiperCallbacks || [];
      window.__lwtSwiperCallbacks.push(callback);
      return;
    }
    window.__lwtSwiperLoading = true;
    window.__lwtSwiperCallbacks = [callback];
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.onload = function () {
      window.__lwtSwiperCallbacks.forEach(function (cb) { cb(); });
      window.__lwtSwiperCallbacks = [];
    };
    document.head.appendChild(script);
  }

  function lwtInitVideos(root) {
    root.querySelectorAll('[data-lwt-video]').forEach(function (frame) {
      if (frame.dataset.lwtInit === 'true') return;
      frame.dataset.lwtInit = 'true';
      var playButton = frame.querySelector('[data-lwt-play]');
      if (!playButton) return;
      playButton.addEventListener('click', function () {
        var videoId = frame.getAttribute('data-video-id');
        if (!videoId) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.allowFullscreen = true;
        frame.innerHTML = '';
        frame.appendChild(iframe);
      });
    });
  }

  function lwtInitSection(section) {
    if (section.dataset.lwtInit === 'true') return;
    section.dataset.lwtInit = 'true';

    lwtInitVideos(section);

    var swiperEl = section.querySelector('[data-lwt-swiper]');
    if (!swiperEl) return;

    lwtLoadSwiperScript(function () {
      new window.Swiper(swiperEl, {
        slidesPerView: 1.1,
        spaceBetween: 20,
        grabCursor: true,
        pagination: {
          el: swiperEl.querySelector('[data-lwt-pagination]'),
          clickable: true
        },
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 24
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 28
          }
        }
      });
    });
  }

  function lwtInitAll(root) {
    (root || document).querySelectorAll('.lwt').forEach(lwtInitSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    lwtInitAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    lwtInitAll(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('testimonial-video-slider')) {
    class TestimonialVideoSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.dotsHost = this.querySelector('[data-dots]');
        this.nav = this.querySelector('[data-nav]');
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.measure = this.querySelector('[data-measure]');
        this.modal = this.querySelector('[data-modal]');
        this.dialog = this.querySelector('[data-modal-dialog]');
        this.playerHost = this.querySelector('[data-modal-player]');

        if (!this.track || !this.viewport) return;

        this.domain = this.dataset.ytDomain || 'https://www.youtube.com';
        this.gap = parseInt(this.dataset.gap, 10) || 0;
        this.peek = parseInt(this.dataset.peek, 10) || 0;
        this.loop = this.dataset.loop === 'true';
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) || 5000;
        this.speed = parseInt(this.dataset.speed, 10) || 600;

        this.realSlides = Array.from(this.track.querySelectorAll('[data-slide]'));
        this.count = this.realSlides.length;
        if (!this.count) return;

        this.index = 0;
        this.slideWidth = 0;
        this.offset = 0;
        this.dragging = false;
        this.moved = 0;
        this.timer = null;

        this.handleKeydown = this.handleKeydown.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        if (this.loop && this.count > 1) this.buildClones();
        this.slides = Array.from(this.track.querySelectorAll('[data-slide]'));
        this.index = this.loop && this.count > 1 ? this.count : 0;

        this.buildDots();
        this.bindEvents();
        this.layout();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        document.removeEventListener('keydown', this.handleKeydown);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.unlockScroll();
      }

      buildClones() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();

        this.realSlides.forEach((slide) => {
          const a = slide.cloneNode(true);
          const b = slide.cloneNode(true);
          [a, b].forEach((clone) => {
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-clone', '');
            clone.querySelectorAll('button').forEach((btn) => btn.setAttribute('tabindex', '-1'));
          });
          before.appendChild(a);
          after.appendChild(b);
        });

        this.track.appendChild(after);
        this.track.insertBefore(before, this.track.firstChild);
      }

      perView() {
        const w = window.innerWidth;
        if (w <= 749) return Math.max(1, parseInt(this.dataset.perViewMobile, 10) || 1);
        if (w <= 989) return Math.max(1, parseInt(this.dataset.perViewTablet, 10) || 2);
        return Math.max(1, parseInt(this.dataset.perViewDesktop, 10) || 2);
      }

      pageCount() {
        if (this.loop) return this.count;
        return Math.max(1, this.count - this.perView() + 1);
      }

      buildDots() {
        if (!this.dotsHost) return;
        this.dotsHost.innerHTML = '';
        const total = this.pageCount();

        if (total <= 1) {
          if (this.nav) this.nav.setAttribute('hidden', '');
          return;
        }
        if (this.nav) this.nav.removeAttribute('hidden');

        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ylt__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', () => {
            this.goTo(this.loop ? this.count + i : i);
            this.restartAutoplay();
          });
          this.dotsHost.appendChild(dot);
        }
        this.dots = Array.from(this.dotsHost.children);
      }

      bindEvents() {
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.goTo(this.index - 1);
            this.restartAutoplay();
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.goTo(this.index + 1);
            this.restartAutoplay();
          });
        }

        this.track.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-video-trigger]');
          if (!trigger) return;
          if (Math.abs(this.moved) > 6) {
            event.preventDefault();
            return;
          }
          this.openModal(trigger);
        });

        this.querySelectorAll('[data-modal-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeModal());
        });
        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.closeModal();
          });
        }

        this.viewport.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('dragstart', (e) => e.preventDefault());

        this.track.addEventListener('transitionend', (event) => {
          if (event.target !== this.track || event.propertyName !== 'transform') return;
          this.normalize();
        });

        this.viewport.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') { this.goTo(this.index - 1); this.restartAutoplay(); }
          if (event.key === 'ArrowRight') { this.goTo(this.index + 1); this.restartAutoplay(); }
        });

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopAutoplay();
          else this.startAutoplay();
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.layout());
          this.resizeObserver.observe(this);
        } else {
          window.addEventListener('resize', () => this.layout());
        }
      }

      layout() {
        const containerWidth = this.measure ? this.measure.getBoundingClientRect().width : this.getBoundingClientRect().width;
        const viewportWidth = this.viewport.getBoundingClientRect().width;
        if (!containerWidth || !viewportWidth) return;

        const perView = this.perView();
        const usable = Math.max(120, containerWidth - this.peek * 2);
        this.slideWidth = (usable - this.gap * (perView - 1)) / perView;
        this.offset = (viewportWidth - usable) / 2;

        this.slides.forEach((slide) => {
          slide.style.width = this.slideWidth + 'px';
        });

        if (!this.loop) {
          const max = Math.max(0, this.count - perView);
          if (this.index > max) this.index = max;
          if (this.index < 0) this.index = 0;
        }

        if (this.lastPerView !== perView) {
          this.lastPerView = perView;
          this.buildDots();
        }

        this.apply(false);
        this.updateUI();
      }

      positionFor(index) {
        return this.offset - index * (this.slideWidth + this.gap);
      }

      apply(animate) {
        this.track.classList.toggle('is-animating', !!animate);
        this.track.style.transform = 'translate3d(' + this.positionFor(this.index) + 'px, 0, 0)';
      }

      goTo(index) {
        if (this.loop) {
          this.index = index;
        } else {
          const max = Math.max(0, this.count - this.perView());
          this.index = Math.min(Math.max(index, 0), max);
        }
        this.apply(true);
        this.updateUI();
      }

      normalize() {
        if (!this.loop) return;
        let changed = false;
        if (this.index >= this.count * 2) { this.index -= this.count; changed = true; }
        if (this.index < this.count) { this.index += this.count; changed = true; }
        if (!changed) return;

        this.track.classList.remove('is-animating');
        this.track.style.transform = 'translate3d(' + this.positionFor(this.index) + 'px, 0, 0)';
        void this.track.offsetWidth;
      }

      activePage() {
        if (!this.loop) return this.index;
        return ((this.index - this.count) % this.count + this.count) % this.count;
      }

      updateUI() {
        const active = this.activePage();
        if (this.dots) {
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === active);
            dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
          });
        }
        if (!this.loop) {
          const max = Math.max(0, this.count - this.perView());
          if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
          if (this.nextBtn) this.nextBtn.disabled = this.index >= max;
        }
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        this.dragging = true;
        this.moved = 0;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.axis = null;
        this.startPos = this.positionFor(this.index);
        this.track.classList.remove('is-animating');
        this.track.classList.add('is-dragging');
        this.stopAutoplay();
        window.addEventListener('pointermove', this.onPointerMove, { passive: false });
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;

        if (!this.axis) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          this.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        if (this.axis === 'y') return;

        event.preventDefault();
        this.moved = dx;
        this.track.style.transform = 'translate3d(' + (this.startPos + dx) + 'px, 0, 0)';
      }

      onPointerUp() {
        if (!this.dragging) return;
        this.dragging = false;
        this.track.classList.remove('is-dragging');
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);

        const threshold = Math.min(90, this.slideWidth * 0.18);
        if (this.moved <= -threshold) this.goTo(this.index + 1);
        else if (this.moved >= threshold) this.goTo(this.index - 1);
        else this.apply(true);

        this.startAutoplay();
        window.setTimeout(() => { this.moved = 0; }, 30);
      }

      startAutoplay() {
        if (!this.autoplay || this.timer || this.pageCount() <= 1) return;
        if (this.modal && !this.modal.hasAttribute('hidden')) return;
        this.timer = window.setInterval(() => {
          if (!this.loop && this.index >= this.count - this.perView()) this.goTo(0);
          else this.goTo(this.index + 1);
        }, this.autoplayDelay);
      }

      stopAutoplay() {
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      openModal(trigger) {
        const id = trigger.getAttribute('data-video-id');
        if (!id || !this.modal) return;

        window.clearTimeout(this.closeTimer);
        this.stopAutoplay();
        this.lastFocused = trigger;

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', this.domain + '/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1');
        iframe.setAttribute('title', trigger.getAttribute('data-video-title') || 'Video');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');

        this.playerHost.innerHTML = '';
        this.playerHost.appendChild(iframe);
        this.modal.removeAttribute('hidden');
        this.lockScroll();

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.modal.classList.add('is-open');
            const closeBtn = this.modal.querySelector('.ylt__modal-close');
            if (closeBtn) closeBtn.focus();
          });
        });

        document.addEventListener('keydown', this.handleKeydown);
      }

      closeModal() {
        if (!this.modal || this.modal.hasAttribute('hidden')) return;

        this.modal.classList.remove('is-open');
        document.removeEventListener('keydown', this.handleKeydown);
        this.unlockScroll();

        this.closeTimer = window.setTimeout(() => {
          this.modal.setAttribute('hidden', '');
          this.playerHost.innerHTML = '';
          this.startAutoplay();
        }, 320);

        if (this.lastFocused) {
          this.lastFocused.focus();
          this.lastFocused = null;
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          this.closeModal();
        }
      }

      lockScroll() {
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }

      unlockScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }

    customElements.define('testimonial-video-slider', TestimonialVideoSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-content-rows"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('youtube-video-rows')) {
    class YouTubeVideoRows extends HTMLElement {
      connectedCallback() {
        this.modal = this.querySelector('[data-modal]');
        this.dialog = this.querySelector('[data-modal-dialog]');
        this.playerHost = this.querySelector('[data-modal-player]');
        this.domain = this.dataset.ytDomain || 'https://www.youtube.com';
        this.lastFocused = null;
        this.closeTimer = null;

        this.handleKeydown = this.handleKeydown.bind(this);

        this.querySelectorAll('[data-video-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => this.open(trigger));
        });

        this.querySelectorAll('[data-modal-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.close();
          });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        this.unlockScroll();
      }

      open(trigger) {
        const id = trigger.getAttribute('data-video-id');
        if (!id || !this.modal) return;

        window.clearTimeout(this.closeTimer);
        this.lastFocused = trigger;

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', this.domain + '/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1');
        iframe.setAttribute('title', trigger.getAttribute('data-video-title') || 'Video');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('frameborder', '0');

        this.playerHost.innerHTML = '';
        this.playerHost.appendChild(iframe);

        this.modal.removeAttribute('hidden');
        this.lockScroll();

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            this.modal.classList.add('is-open');
            const closeBtn = this.modal.querySelector('.ylv__modal-close');
            if (closeBtn) closeBtn.focus();
          });
        });

        document.addEventListener('keydown', this.handleKeydown);
      }

      close() {
        if (!this.modal || this.modal.hasAttribute('hidden')) return;

        this.modal.classList.remove('is-open');
        document.removeEventListener('keydown', this.handleKeydown);
        this.unlockScroll();

        this.closeTimer = window.setTimeout(() => {
          this.modal.setAttribute('hidden', '');
          this.playerHost.innerHTML = '';
        }, 320);

        if (this.lastFocused) {
          this.lastFocused.focus();
          this.lastFocused = null;
        }
      }

      handleKeydown(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          event.preventDefault();
          this.close();
        }
      }

      lockScroll() {
        this.scrollY = window.scrollY;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      }

      unlockScroll() {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }

    customElements.define('youtube-video-rows', YouTubeVideoRows);
  }

  } catch(e) { console.error(e); }
})();
})();
